<template>
  <div class="facility-item">
    <vb-icon class="facility-item__icon" :name="get_accommodation_facilities(item.id).icon" :color="'f1ae04'" :size="14" />
    <span class="facility-item__text">{{ get_accommodation_facilities(item.id).label }}</span>
  </div>
</template>

<script>
import { get_accommodation_facilities } from '@bookingv3/resources'

export default {
  name: 'facility',

  components: {
  },

  props: {
    item: Object,
  },

  data() {
    return {
    }
  },

  computed: {
  },

  created() {
    this.get_accommodation_facilities = get_accommodation_facilities
  },

  mounted() {
  },

  methods: {
  },
}
</script>

<style lang="scss" scoped>

  .facility-item {
    display: flex;
    align-items: center;

    &__icon {
      margin-top: 2px;
      margin-right: 10px;
    }
  }

</style>